<template>
  <div class="home-page-wrapper about-page-wrapper">
    <HeroBanner
      image-url-present
      :title="pricingDetaiPictures.title"
      :image-url="generateImageUrl(pricingDetaiPictures.image)"
    />
    <PriceDetail :pricing-detail="getPricing()" />
    <PriceComparison />
    <Faq :data="faq" :extraClass="['grey-bg']" />
  </div>
</template>

<script>
import HeroBanner from "@/pageComponents/globalUi/hero-banner";
import PriceDetail from "@/pageComponents/pricing-detail/price-details";
import PriceComparison from "@/pageComponents/pricing-detail/price-comparison";
import Faq from "@/pageComponents/globalUi/faq";
import { FaqData } from "./data";
import { mapGetters } from "vuex";

const MISC_STORE_KEY = "miscStore";

export default {
  name: "PricingDetail",
  mounted() {
    if (this.onlyPlayer()) {
      this.$store.dispatch(`${MISC_STORE_KEY}/getPricingDetail`, {
        type: "player"
      });
      this.$store.dispatch(`${MISC_STORE_KEY}/getFaq`, {
        faqType: "athletePricing"
      });
      this.$store.dispatch(`${MISC_STORE_KEY}/getPricingPictures`, {
        type: "Athlete"
      });
    } else {
      this.$store.dispatch(`${MISC_STORE_KEY}/getPricingDetail`, {
        type: "premiumclubHeadCoach"
      });
      this.$store.dispatch(`${MISC_STORE_KEY}/getFaq`, {
        faqType: "clubCoachPricing"
      });
      this.$store.dispatch(`${MISC_STORE_KEY}/getPricingPictures`, {
        type: "Club"
      });
    }
  },
  computed: {
    ...mapGetters({
      pricingDetail: `${MISC_STORE_KEY}/pricingDetail`,
      formattedPricingDetail: `${MISC_STORE_KEY}/formattedPricingDetail`,
      formattedAtheletePricingDetail:`${MISC_STORE_KEY}/formattedAtheletePricingDetail`,
      faq: `${MISC_STORE_KEY}/faq`,
      pricingDetaiPictures: `${MISC_STORE_KEY}/pricingDetaiPictures`
    })
  },
  components: {
    HeroBanner,
    PriceDetail,
    PriceComparison,
    Faq
  },
  methods:{
    getPricing(){
      if(localStorage.getItem('user-permissions') != '"player"'){
        return this.formattedPricingDetail;
      }else{
        return this.formattedAtheletePricingDetail;
      }
    }
  },
  data() {
    return {
      FaqData
    };
  }
};
</script>

<style></style>
